import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  FormGroup,
  FormControl,
  InputGroup,
  Glyphicon,
  DropdownButton,
  MenuItem,
  ButtonGroup,
  Modal,
  ControlLabel
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import {
  allUser, storeCredit
} from "../../../redux/actions/subAdminActions";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import Dialog from "react-bootstrap-dialog";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import "../../../style/listPage.scss";
import DatePicker from "react-date-picker";

import {aclUtil} from "../../util"

const history = createBrowserHistory();
class UserList extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      userList: [],
      limit: 25,
      totalRecords: 0,
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      path: ["Home", "Store Credits"],
      links:["home", ""],
      show: false,
      emailSortIcon: "",
      firstNameSortIcon: "",
      lastNameSortIcon: "",
      userNameSortIcon: "",
      direction: "",
      orderBy: "",
      searchString: "",
      search: "",
      popUpStatus: false,
      userID: '',
      method: '',
      reason: '',
      expiryDate: '',
      amount: '',
    };
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  hadleStoreCredit = (e) => {
  	let valid = this.validation();
  	if(valid){
  		const constData = {
  			provided_to: this.state.userID,
  			credit: this.state.amount,
  			reason: this.state.reason,
  			expiryDate: this.state.expiryDate,
  			type: this.state.method,
  		}
  		this.props.storeCredit(constData);
  	}
  }

  validation = (e) => {
  	let response = true;

  	if(!this.state.amount){
  		response = false;
  		this.setState({amountError: 'red'});
  	}

  	if(!this.state.reason){
  		response = false;
  		this.setState({reasonError: 'red'});
  	}

  	return response;
  }

  onChangeExpiryDate = date => this.setState({ expiryDate: date });

  handleOnChange = (e) => {
  	if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({[e.target.name]: e.target.value});
  }

  changeStatus = (userID, method) => {
    this.setState({popUpStatus: true, userID: userID, method: method});
  }

  ClosePopup = (e) => {
    this.setState({popUpStatus: false, userID: '', method: '', amount:'', reason:'', expiryDate: ''});
  }

  handleSort = orderBy => e => {
    e.preventDefault();
    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-down",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    let formData = { orderBy: orderBy, direction: direction,limit: this.state.limit };
    if(this.props.match && this.props.match.params && this.props.match.params.userID){
      formData.userID = this.props.match.params.userID;
    }
    this.props.allUser(formData);
  };

  handleSearch = () => e => {
    const searchString = e.target.value;
    let formData = { page: 1,limit: this.state.limit };

    if (searchString.length > 0) {
      formData.search = searchString;
    }
    if(this.props.match && this.props.match.params && this.props.match.params.userID){
      formData.userID = this.props.match.params.userID;
    }
    this.props.allUser(formData);
    this.setState({ searchString: searchString });
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentDidMount() {
    this.handleDismiss();
    this.props.clearAlert();
    let formData = { page: this.state.currentPage,limit: this.state.limit };
    if(this.props.match && this.props.match.params && this.props.match.params.userID){
      formData.userID = this.props.match.params.userID;
    }
    this.props.allUser(formData);
  }
  handlePageChange = page => {
    this.setState({
      currentPage: page
    });
    let formData = { page: page,limit: this.state.limit };
    if (this.state.direction !== "" && this.state.orderBy !== "") {
      formData.orderBy = this.state.orderBy;
      formData.direction = this.state.direction;
    } else if (this.state.searchString !== "") {
      formData.search = this.state.searchString;
    }
    if(this.props.match && this.props.match.params && this.props.match.params.userID){
      formData.userID = this.props.match.params.userID;
    }

    this.props.allUser(formData);
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.userList !== nextProps.userList) {
      if (nextProps.userList) {
        const setPageCount =
          nextProps.userList.total / nextProps.userList.per_page;
        this.setState({
          userList: nextProps.userList.data,
          totalRecords: nextProps.userList.total,
          perPage: nextProps.userList.per_page,
          pageCount: setPageCount
        });
      }
    }

    if(this.props.store !== nextProps.store){
    	if (nextProps.store) {
	        this.setState({ alert: false });
	        this.props.clearAlert();
	        this.handleShow();
	        this.props.renderAlert("success", nextProps.store.message);
	        this.setState({popUpStatus: false, userID: '', method: '', amount:'', reason:'', expiryDate: ''});
	        
          let formData = { page: this.state.currentPage,limit: this.state.limit };
          if(this.props.match && this.props.match.params && this.props.match.params.userID){
            formData.userID = this.props.match.params.userID;
          }
          this.props.allUser(formData);
	    }
    }
    
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.setState({ alert: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }

    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  storeCreditPreview = (userID) => {
  		this.context.router.history.push(`/store-credit-preview/${userID}`);
  }

  render() {
    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    let userRow;
    if (!isEmpty(this.props.userList)) {
      userRow = this.props.userList.data.map((user, index) => (
        <tr key={user.user_id}>
          <td>{user.email}</td>
          <td>{user.userName}</td>
          <td>{user.firstName} {user.lastName}</td>
          <td>{user.UserTypeName}</td>
          <td>${user.remaining_store_credit}</td>
          <td>
            	<ButtonGroup bsStyle="success">
				  <DropdownButton title="Action" id="bg-nested-dropdown">
				    {aclUtil.checkACL('ADD_REMOVE_STORE_CREDIT') ? (<MenuItem eventKey="1" 
				    onClick={this.changeStatus.bind(
	                  this,
	                  user.user_id,
	                  'deposit'
	                )}>Add Credit</MenuItem>) :("")}
	                {(user.remaining_store_credit > 0) &&
					    aclUtil.checkACL('ADD_REMOVE_STORE_CREDIT') ? (<MenuItem eventKey="2"
					    onClick={this.changeStatus.bind(
		                  this,
		                  user.user_id,
		                  'withdrawl'
		                )}>Remove Credit</MenuItem>) :("")
	                }
	                {aclUtil.checkACL('ADD_REMOVE_STORE_CREDIT') ? (<MenuItem eventKey="3" onClick={this.storeCreditPreview.bind(this, user.user_id)}>Store Credit Preview</MenuItem>) :("")}
				  </DropdownButton>
				</ButtonGroup>
          </td>
        </tr>
      ));
    }

    return (
      <div>
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        <div className="col-lg-12 user-list list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Store Credits</header>

            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="clearfix" />
              <div className="row m-t-15">
                <div className="col-lg-4 pull-right">
                  <FormGroup>
                    <InputGroup>
                      <FormControl
                        type="text"
                        name="search"
                        onChange={this.handleSearch()}
                      />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
              </div>
              <div className="col-lg-12">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th onClick={this.handleSort("email")}>
                        Email<span
                          className={this.state.emailSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th onClick={this.handleSort("userName")}>
                        User Name<span
                          className={this.state.userNameSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th onClick={this.handleSort("firstName")}>
                        Name<span
                          className={this.state.firstNameSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th>User Type</th>
                      <th>Store Credit</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>{userRow}</tbody>
                </table>

                <div className="text-center">
                  <Pagination
                    total={totalRecords}
                    limit={perPage}
                    pageCount={5}
                    currentPage={currentPage}
                  >
                    {({
                      pages,
                      currentPage,
                      hasNextPage,
                      hasPreviousPage,
                      previousPage,
                      nextPage,
                      totalPages,
                      getPageItemProps
                    }) => (
                      <div className="pagination">
                        <button
                          {...getPageItemProps({
                            pageValue: 1,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          first
                        </button>

                        {hasPreviousPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: previousPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {"<"}
                          </button>
                        )}

                        {pages.map(page => {
                          let activePage = null;
                          if (currentPage === page) {
                            activePage = {
                              backgroundColor: "#ccc",
                              color: "#666"
                            };
                          }
                          return (
                            <button
                              key={page}
                              style={activePage}
                              {...getPageItemProps({
                                pageValue: page,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {hasNextPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: nextPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {">"}
                          </button>
                        )}

                        <button
                          {...getPageItemProps({
                            pageValue: totalPages,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          last
                        </button>
                      </div>
                    )}
                  </Pagination>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
        <Modal show={this.state.popUpStatus} onHide={this.ClosePopup}>
          <Modal.Header closeButton>
            <Modal.Title><i className="fa fa-money"></i>{" "}{(this.state.method === 'deposit') ? 'Add Store Credit' : 'Remove Store Credit'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
             <p className="text-danger">The reason can be seen by the user, keep it clean and unpretentious</p>
             <FormGroup>
                  <ControlLabel>Reason</ControlLabel>
                  <FormControl
                    type="text"
                    value={this.state.reason}
                    placeholder="Enter Reason"
                    name="reason"
                    onChange={this.handleOnChange}
                    style={{borderColor:this.state.reasonError}}
                  />
            </FormGroup>
            <FormGroup>
                <ControlLabel>Amount</ControlLabel>
			    <InputGroup>
			      <DropdownButton
			        componentClass={InputGroup.Button}
			        id="input-dropdown-addon"
			        title="$"
			      >
			        <MenuItem key="$">$</MenuItem>
			      </DropdownButton>
			      <FormControl 
			      	type="number" 
			      	value={this.state.amount} 
			      	onChange={this.handleOnChange}
			      	name="amount"
                    style={{borderColor:this.state.amountError}} 
                   />
			    </InputGroup>
			</FormGroup>
			{(this.state.method === 'deposit') &&
			<FormGroup>
                <ControlLabel>Expiry Date (Optional)</ControlLabel><br/>
                <DatePicker
                        onChange={this.onChangeExpiryDate}
                        value={this.state.expiryDate}
                      />
            </FormGroup>
        	}
          </Modal.Body>
          <Modal.Footer>
            {(this.state.method === 'deposit') ?
            	<Button bsStyle="success" onClick={this.hadleStoreCredit}>Deposit</Button>
            :
           		<Button bsStyle="danger" onClick={this.hadleStoreCredit}>Withdrawal</Button>
        	}
            <Button bsStyle="primary" onClick={this.ClosePopup}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

UserList.propTypes = {
  allUser: PropTypes.func.isRequired,
  storeCredit: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  userList: state.subAdminReducer.userList,
  error: state.subAdminReducer.error,
  alertType: state.alertsReducer.alertType,
  store: state.subAdminReducer.store,
  message: state.alertsReducer.message
});

export default connect(mapStateToProps, {
  allUser,
  renderAlert,
  clearAlert,
  storeCredit
})(UserList);



// WEBPACK FOOTER //
// ./src/app/views/admin/user/UserList.js